import { Injectable } from "@angular/core";
import { Actions, Effect } from "@ngrx/effects";
import { EnquiryService } from "@services/enquiry";
import { MatrixClassService } from "@services/matrix-class";
import {
  FETCH_ENQUIRIES,
  POPULATE_ENQUIRIES,
  FETCH_ENQUIRIES_FAILURE,
  FETCH_ENQUIRY,
  POPULATE_ACTIVE_ENQUIRY,
  FETCH_ENQUIRY_FAILURE,
  UPDATE_ENQUIRY,
  REPLACE_ENQUIRY,
  UPDATE_ENQUIRY_FAILURE,
  CREATE_ENQUIRY,
  CREATE_ENQUIRY_FAILURE,
  ADD_ENQUIRY,
  FETCH_ENQUIRY_BY_GUID,
  FETCH_ENQUIRY_CLASSES,
  POPULATE_ENQUIRY_CLASSES,
  FETCH_ENQUIRY_CLASSES_FAILURE,
  CONVERT_ENQUIRY_TO_CONTACT,
  CONVERT_ENQUIRY_TO_CONTACT_FAILURE,
  CONVERTED_ENQUIRY_TO_CONTACT
} from "../enquiries";
import { Observable } from "rxjs/Observable";
import { Enquiry } from "@models/enquiry";
import { Action } from "@ngrx/store";
import { MatrixClass } from "@models/matrix-class";

@Injectable()
export class EnquiryEffects {

  constructor(
    private actions: Actions,
    private enquiryService: EnquiryService,
    private matrixClassService: MatrixClassService,
  ) {}

  @Effect() fetchEnquiries = this.actions
    .ofType(FETCH_ENQUIRIES)
    .switchMap(() => this.enquiryService.index()
      .map((enquiries: Enquiry[]) => ({ type: POPULATE_ENQUIRIES, payload: enquiries }))
      .catch(() => Observable.of({ type: FETCH_ENQUIRIES_FAILURE }))
    )
    .share()

  @Effect() fetchEnquiry = this.actions
    .ofType(FETCH_ENQUIRY)
    .map((action: Action) => action.payload)
    .switchMap((payload: number) => this.enquiryService.fetch(payload)
      .map((enquiries: Enquiry) => ({ type: POPULATE_ACTIVE_ENQUIRY, payload: enquiries }))
      .catch(() => Observable.of({ type: FETCH_ENQUIRY_FAILURE }))
    )
    .share()

  @Effect() fetchEnquiryByGuid = this.actions
    .ofType(FETCH_ENQUIRY_BY_GUID)
    .map((action: Action) => action.payload)
    .switchMap((payload: string) => this.enquiryService.fetchByGuid(payload)
      .map((enquiries: Enquiry) => ({ type: POPULATE_ACTIVE_ENQUIRY, payload: enquiries }))
      .catch((response) => Observable.of({ type: FETCH_ENQUIRY_FAILURE }))
    )
    .share()

  @Effect() updateEnquiry = this.actions
    .ofType(UPDATE_ENQUIRY)
    .map((action: Action) => action.payload)
    .switchMap((payload: Enquiry) => this.enquiryService.update(payload.serializeForRails())
      .map((enquiry: Enquiry) => ({ type: REPLACE_ENQUIRY, payload: enquiry }))
      .catch((response) => Observable.of({ type: UPDATE_ENQUIRY_FAILURE, payload: response }))
    )
    .share()

  @Effect() createEnquiry = this.actions
    .ofType(CREATE_ENQUIRY)
    .map((action: Action) => action.payload)
    .switchMap((payload: Enquiry) => this.enquiryService.create(payload.serializeForRails())
      .map((enquiry: Enquiry) => ({ type: ADD_ENQUIRY, payload: enquiry }))
      .catch((response) => Observable.of({ type: CREATE_ENQUIRY_FAILURE, payload: response }))
    )
    .share()

  @Effect() fetchPotentialClasses = this.actions
    .ofType(FETCH_ENQUIRY_CLASSES)
    .map((action: Action) => action.payload)
    .switchMap((params: any) => this.matrixClassService.index(params)
      .map((classes: MatrixClass[]) => ({ type: POPULATE_ENQUIRY_CLASSES, payload: classes }))
      .catch((response) => Observable.of({ type: FETCH_ENQUIRY_CLASSES_FAILURE, payload: response }))
    )
    .share()

  @Effect() convertEnquiryToContact = this.actions
    .ofType(CONVERT_ENQUIRY_TO_CONTACT)
    .map((action: Action) => action.payload)
    .switchMap((params: any) => this.enquiryService.convertEnquiryToContact(params.id, params.contactType)
      .map((classes: boolean) => ({ type: CONVERTED_ENQUIRY_TO_CONTACT }))
      .catch((response) => Observable.of({ type: CONVERT_ENQUIRY_TO_CONTACT_FAILURE, payload: response }))
    )
    .share()
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/effects/enquiry.ts